<template>
  <Select :options="fieldOptions" v-model="field" @changeValue="changeValue('field', $event)" placeholder="Field" :disabled="disabled" />
  <Select v-if="field == 'attribute'" source="term/search-attribute" v-model="attribute" @changeValue="changeValue('attribute', $event)" placeholder="Attribute" :disabled="disabled" />
</template>

<script>
import DefaultPackage from './DefaultPackage.vue'
export default {
  extends: DefaultPackage,
  emits: ['changeValue'],
  data() {
    return {
      field: '',
      attribute: ''
    }
  },
  computed: {
    value() {
      return this.config.value
    },
    fieldOptions() {
      return Object.entries(this.packages?.[this.config?.parentPackage]?.fields || {}).reduce((result, [key, value]) => {
        result.push({
          id: key,
          text: value.label
        })
        return result
      }, [])
    }
  },
  watch: {
    value: {
      handler(values) {
        this.field = values?.field
        this.attribute = values?.attribute
      },
      immediate: true
    }
  }
}
</script>
